
import { Component, OnDestroy, Renderer2, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { SiriusBaseComponent } from 'sirius-framework';
import { Subscription } from 'rxjs';
import { FaqContent } from '../shared/models/menuItem';
import { CommonService } from '../shared/service/shared.service';
import { SiteLanguageService } from '../shared/service/site-language.service';

declare const $: any;

const FAQ_KEYS = {
    pageTitle: 'yediEminFaqPageTitle',
};

const FAQ_DEFAULT_PAGE_TITLE = 'Sık Sorulan Sorular';

@Component({
    selector: 'app-faq',
    templateUrl: './faq.component.html',
    styleUrls: ['./faq.component.css']
})
export class FaqComponent extends SiriusBaseComponent<any> implements OnDestroy {
    pageTitle: string = FAQ_DEFAULT_PAGE_TITLE;
    sssContent: Array<FaqContent>;
    @ViewChildren('elementTitles') elementTitles: QueryList<ElementRef>;

    private langSub: Subscription;

    constructor(
        private renderer: Renderer2,
        private commonService: CommonService,
        private siteLanguageService: SiteLanguageService,
    ) {
      super();
      this.commonService.urlService();
  }

    OnInit() {
        this.langSub = this.siteLanguageService.languageCode$.subscribe(() => {
            this.loadFaqStringsAndContent();
        });
  }

    ngOnDestroy() {
        if (this.langSub) {
            this.langSub.unsubscribe();
        }
    }

    private loadFaqStringsAndContent(): void {
        this.pageTitle = this.commonService.getStringResource(FAQ_KEYS.pageTitle, FAQ_DEFAULT_PAGE_TITLE);

        const faqContent = this.commonService.getStringResource('yediEminFaqContent', '');
        this.sssContent = new Array<FaqContent>();
        if (!faqContent) {
            return;
        }
        const questionAndAnswers = faqContent.split('#');
        for (let i = 0; i < questionAndAnswers.length; i++) {
            const faqItem = new FaqContent();
            const singleQa = questionAndAnswers[i].split('|');
            faqItem.question = singleQa[0];
            faqItem.answer = singleQa[1];
            this.sssContent.push(faqItem);
        }
  }

  elementTitleClicked(i: number) {
    var elementList = this.elementTitles.toArray();
    for (let j = 0; j < elementList.length; j++) {
      if (j == i) {
        if (elementList[j].nativeElement.children[0].classList.contains("open")) {
          this.renderer.removeClass(elementList[j].nativeElement.children[0], 'open');
          this.renderer.removeClass(elementList[j].nativeElement.children[1], 'show');
        }
        else {
          this.renderer.addClass(elementList[j].nativeElement.children[0], 'open');
          this.renderer.addClass(elementList[j].nativeElement.children[1], 'show');
        }
      }
      else {
        this.renderer.removeClass(elementList[j].nativeElement.children[0], 'open');
        this.renderer.removeClass(elementList[j].nativeElement.children[1], 'show');
      }
    }
    $(document).ready(() => {
      $(".list-group").animate({ scrollTop: $('#elementTitleOfSearchResult' + i).height() * i }, 600);
    });
  }
}
